// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"_Y-z"};